module.exports = __webpack_public_path__ + "static/media/ncl_schedule-table-mobile.a754edc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/ncl_schedule-table-mobile.png
// module id = 385
// module chunks = 0